import { render, staticRenderFns } from "./NavPrevBt.vue?vue&type=template&id=fa87d806&scoped=true"
import script from "./NavPrevBt.vue?vue&type=script&lang=js"
export * from "./NavPrevBt.vue?vue&type=script&lang=js"
import style0 from "./NavPrevBt.vue?vue&type=style&index=0&id=fa87d806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa87d806",
  null
  
)

export default component.exports